export default "__VITE_ASSET__DKaTmx8n__"